import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Categories from "@/pages/Categories";
import ProjectDetail from "@/pages/ProjectDetail";
import PublishProject from "@/pages/PublishProject";
import UserProfile from "@/pages/UserProfile";
import Favorites from "@/pages/Favorites";
import Dashboard from "@/pages/Dashboard";
import Notifications from "@/pages/Notifications";
import AdminDashboard from "@/pages/AdminDashboard";
import Auth from "@/pages/Auth";
import Marketplace from "@/pages/Marketplace";
import ListingDetail from "@/pages/ListingDetail";
import SellListing from "@/pages/SellListing";
import MarketPanel from "@/pages/MarketPanel";
import SellerPage from "@/pages/SellerPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { ClerkBridge } from "@/components/auth/ClerkBridge";
import GoogleAuthPage from "@/pages/GoogleAuthPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <ClerkAuthProvider>
          <ClerkBridge />
          <Routes>
            <Route path="/sign-in/*" element={<GoogleAuthPage mode="in" />} />
            <Route path="/sign-up/*" element={<GoogleAuthPage mode="up" />} />
            <Route path="/entrar" element={<Auth mode="login" />} />
            <Route path="/cadastro" element={<Auth mode="register" />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/explorar" element={<Explore />} />
              <Route path="/categorias" element={<Categories />} />
              <Route path="/projeto/:slug" element={<ProjectDetail />} />
              <Route path="/u/:username" element={<UserProfile />} />
              <Route path="/publicar" element={<ProtectedRoute><PublishProject /></ProtectedRoute>} />
              <Route path="/favoritos" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
              <Route path="/painel" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/notificacoes" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
              <Route path="/mercado" element={<Marketplace />} />
              <Route path="/mercado/anuncio/:id" element={<ListingDetail />} />
              <Route path="/mercado/vendedor/:id" element={<SellerPage />} />
              <Route path="/mercado/anunciar" element={<ProtectedRoute><SellListing /></ProtectedRoute>} />
              <Route path="/mercado/editar/:id" element={<ProtectedRoute><SellListing /></ProtectedRoute>} />
              <Route path="/mercado/painel" element={<ProtectedRoute><MarketPanel /></ProtectedRoute>} />
              <Route path="/pagamento/sucesso" element={<PaymentSuccess />} />
              <Route path="/pagamento/cancelado" element={<PaymentCancel />} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            </Route>
          </Routes>
          </ClerkAuthProvider>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
